import { LowerCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxDatePipe, OnyxFormMode } from '@onyx/angular';
import { DictionaryCode } from '../../../../../../common/enums/dictionary-code';
import type { ContractorDocument } from '../../interfaces/contractor-documents';

@Component({
  selector: 'app-contractor-documents-form-information-cell',
  imports: [OnyxDatePipe, TranslatePipe, LowerCasePipe],
  templateUrl: './contractor-documents-form-information-cell.component.html',
  styleUrl: './contractor-documents-form-information-cell.component.scss',
})
export class ContractorDocumentsFormInformationCellComponent {
  public readonly document = input.required<ContractorDocument | null>();
  public readonly mode = input.required<OnyxFormMode>();

  protected readonly DictionaryCode = DictionaryCode;
  protected readonly OnyxFormMode = OnyxFormMode;
}
